import { ControllerProps } from "csi/middleware/common";
import Select from "designSystem/components/select/Select";
import { red } from "designSystem/styles/color";
import {
	FlexRowCenter,
	Text,
} from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { FunctionComponent } from "react";
import { useProductHierarchySelectStore } from "./ProductHierarchySelectStore";

/** default values are used if styling props are not passed down */
const width = "40%";
const padding = "15px";
const paddingInline = "5%";

export interface ProductHierarchySelectSingleSelectProps extends ControllerProps {
    /** the type of product hierarchy folder */
    label: string;

    /** the level of the product hierarchy folder */
    i: number;

    /** boolean determining if errors should start being displayed */
    error?: boolean;
}

const ProductHierarchySingleSelect: FunctionComponent<ProductHierarchySelectSingleSelectProps> = observer((props) => {
	const { label, i, error, ...otherProps } = props;
	const store = useProductHierarchySelectStore();
	const {
		focused,
		setFocused,
		folderValues,
		setFolderValues,
		folderItems,
		emptyErrorMessage,
	} = store || {};

	/** 
     * errors are displayed if either the form has been submitted incomplete or if the user has clicked out
     * and the form is not disabled and empty
     */
	const selectError = (): boolean => {
		return (error || focused) && !folderValues[i] && i !== 0 && folderValues[i - 1] !== "";
	};

	const errorMessage: String = selectError() ? emptyErrorMessage : "";

	return (
		store && (
			<FlexRowCenter paddingX={paddingInline}>
				<FlexRowCenter
					justifyContent="flex-end"
					padding={padding}
					width={width}
				>
					<Text
						align="right"
						bold
						text={label}
					/>
					{i !== 0 && (
						<Text
							align="right"
							bold
							color={red[400]}
							text="*"
						/>
					)}
				</FlexRowCenter>
				<Select
					disabled={i == 0 || !folderValues[i - 1]}
					error={selectError()}
					fullWidth
					helperText={errorMessage}
					items={folderItems[i]}
					onBlur={(_) => setFocused(true)}
					onChange={(e) => setFolderValues(e.target.value, i)}
					value={folderValues[i]}
				/>
			</FlexRowCenter>
		)
	);
});

export default ProductHierarchySingleSelect;
